import {useCallback} from 'react';
import {assert} from 'assert-ts';
import {HttpError} from 'api/http/types';
import {type ChangeRequest} from 'api/types';
import {postChangeRequestClose} from 'api/changeRequest';
import {useGetTokens} from 'services/auth';
import {usePutTaskStatusMutation} from 'services/tasks';
import {useMockContext} from 'services/utils/contexts';
import type {SaveStatus} from '../types';

export const useCloseChangeRequest = () => {
  const getTokens = useGetTokens();
  const mock = useMockContext();

  const [putTaskStatus] = usePutTaskStatusMutation();

  return useCallback(
    (
      changeRequestId: string,
      type: ChangeRequest['taskType'],
    ): Promise<SaveStatus | void> => {
      if (type === 'METADATA_IMPORT_CHANGE') {
        return postChangeRequestClose(changeRequestId, getTokens, mock);
      }

      const taskId = parseInt(changeRequestId);
      if (isNaN(taskId) && changeRequestId.toString().length === 0) {
        assert.soft(false, 'saveChangeRequest: could not parse id', {
          id: changeRequestId,
        });
        return Promise.resolve({
          status: 'Failed',
          error: new HttpError(400, '', 'Invalid id'),
        });
      }

      return putTaskStatus({id: taskId, status: 'COMPLETED'}).unwrap();
    },
    [getTokens, mock, putTaskStatus],
  );
};
